import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "8",
  height: "10",
  viewBox: "0 0 8 10",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M7 3.33333H6.5V2.38095C6.5 1.04762 5.4 0 4 0C2.6 0 1.5 1.04762 1.5 2.38095V3.33333H1C0.45 3.33333 0 3.7619 0 4.28571V9.04762C0 9.57143 0.45 10 1 10H7C7.55 10 8 9.57143 8 9.04762V4.28571C8 3.7619 7.55 3.33333 7 3.33333ZM2.45 3.33333V2.38095C2.45 1.57143 3.15 0.904762 4 0.904762C4.85 0.904762 5.55 1.57143 5.55 2.38095V3.33333H2.45ZM4 7.619C4.55 7.619 5 7.19042 5 6.66661C5 6.1428 4.55 5.71423 4 5.71423C3.45 5.71423 3 6.1428 3 6.66661C3 7.19042 3.45 7.619 4 7.619ZM1 9.04767H7V4.28577H1V9.04767Z"
    }, null, -1)
  ]))]))
}
export default { render: render }